import { useContext } from "react";
import { Datagrid, List, SelectInput, TextField, TextInput } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const ClassList = (props) => {

    const context = useContext(AppContext)
    const isTeacher = context.profile.name === ProfileEnum.TEACHER

    const filters = [
        <TextInput label='Nome' source={"q"} alwaysOn />,
        <SelectInput label="Período letivo" source="academic_period" emptyText={"Todos"} emptyValue={"all"} choices={[{ name: "Vigente", id: "current" }]} alwaysOn />,
    ];

    return (
        <List exporter={false} bulkActionButtons={false}
            filters={filters}
            filterDefaultValues={{ "academic_period": "current" }}
            sort={{ field: 'academic_period.start_at', order: 'DESC' }}
            title={'Turmas'}
            {...props}
        >
            <Datagrid rowClick={isTeacher ? 'show' : 'edit'}>
                <TextField source="name" label={'Nome'} />
                <TextField source="academic_period.name" label={'Período Letivo'} sortBy="academic_period.start_at" sortByOrder="DESC" />
                {context.profile.name === ProfileEnum.SUPERADMIN && <TextField source="institution_branch.institution.name" label={'Instituição'} />}
                {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && <TextField source="institution_branch.name" label={'Unidade'} />}

            </Datagrid>
        </List>
    )
}

export default ClassList;